<template>
  <div class="arrow-container">
    <button @click.prevent="nextJob()" v-if="hasRecommendations && !hideArrow">
      <svg-chevron-left class="next"></svg-chevron-left>
    </button>
  </div>
</template>

<script>
  import RecommendedJobs from '@/mixins/RecommendedJobs';

	export default {
		name: 'JobsRecommendedNext',

    mixins: [RecommendedJobs],

		props: {
      jobid: {
        type: String
      }
		},

		data() {
			return {
        recommended_jobs: false,
        hideArrow: true,
				manager: false
			}
		},

    mounted() {
			this.emitter.on('refresh:recommended:jobs', this.refreshState);
      this.refreshState();
    },

    methods: {
			refreshState() {
				this.recommended_jobs = this.getRecommended();
				this.recommended_jobs.index = this.recommended_jobs.jobs.findIndex((job) => {return job.objectID == this.jobid});
				this.hideArrow = this.recommended_jobs.index >= this.recommended_jobs.jobs.length - 1;
				console.log("this.recommended_jobs",this.recommended_jobs);
			},
      nextJob() {
        this.recommended_jobs.index = this.recommended_jobs.index + 1;
				console.log("this.recommended_jobs.index",this.recommended_jobs.index);
        this.setRecommended(this.recommended_jobs);
				let target_job = this.recommended_jobs.jobs[this.recommended_jobs.index];
        window.location = this.calculate_link(target_job);
      }
    }
	}
</script>
